// extracted by mini-css-extract-plugin
module.exports = {"c1pooxko":"c1pooxko","l1wwzldj":"l1wwzldj","active":"active"};